import { getGroups } from '../crud/groups.crud'
import useApiControls from './useApiControls'

const INITIAL_DATA = []

export const parseGroupsResponse = (responseData) =>
  responseData?.map((item) => ({
    ...item.rawDataFlat,
    type: item.type,
    visibility: item.visibility ?? item.rawDataFlat?.visibility,
  }))

const useGroupsFetch = () => {
  const { callApi, loading, error, data, success } = useApiControls({
    api: getGroups,
    initialData: INITIAL_DATA,
    parseData: parseGroupsResponse,
  })

  return {
    fetchGroups: callApi,
    isFetchingGroups: loading,
    hasFetchedGroups: success || Boolean(error),
    errorFetchingGroups: error,
    groups: data,
  }
}

export default useGroupsFetch
